document.querySelectorAll('.hambcoll').forEach(function (element) {
  element.addEventListener('click', function () {
    // Find the menu container with the 'hamburger-coll' class and show it
    const menu = document.querySelector('.hamburger-coll');
    if (menu) {
      // Apply fixed positioning for the menu
      menu.style.position = 'fixed';  // Fixed position
      menu.style.display = 'block';   // Make the menu visible
      menu.classList.add('active');   // Add the active class
    }
  });
});
document.querySelectorAll('.close-hamburger').forEach(function (closeButton) {
  closeButton.addEventListener('click', function () {
    const menu = this.closest('.hamburger-coll');
    if (menu) {
      menu.style.display = 'none';    // Hide the menu when close button is clicked
      menu.classList.remove('active'); // Remove the active class
    }
  });
});

document.addEventListener("DOMContentLoaded", function(){
    document.querySelectorAll('.new-navv-src').forEach(function(element) {
      element.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelectorAll('[data-live-search-input]').forEach(function(inputElement) {
              var event = new Event('keyup');
              inputElement.dispatchEvent(event);
          });
      });
    });
    window.addEventListener('cartcount:update', function() {
      setTimeout(function(){
        var item_count = Number(document.querySelector(".site-header .site-header-cart--count").getAttribute("data-header-cart-count"));
        if(item_count > 0){
          if(document.querySelector(".new-sticky-nav .site-header-cart--count").classList.contains("visible") == false ){
            document.querySelector(".new-sticky-nav .site-header-cart--count").classList.add("visible");
          }
          document.querySelector(".new-sticky-nav .site-header-cart--count").setAttribute("data-header-cart-count", item_count);
        }else{
          document.querySelector(".new-sticky-nav .site-header-cart--count").classList.remove("visible");
        }
      }, 20);
    });
  });